import * as React from "react";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import { SFT_Targets } from "../models/SFT_Targets";
import Modal from "react-bootstrap/Modal";
import { DM_PT_DataSheet } from "../models/DM_PT_DataSheet";
import { ProtectiveFunction } from "../models/ProtectiveFunction";
import { DeviceData } from "../models/DeviceData";
import { ManualAction } from "../models/ManualAction";
import { SilModal } from "./SilModal";

interface Props {
    closeModal: () => void;
    device: DeviceData;
    manualAction: ManualAction;
    onManualActionSave: (manualAction: ManualAction) => void;
    saveManualActionsFailed: (e: React.MouseEvent) => void;
}

interface State {
    closeFocus: boolean;
}

export class ManualActionModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { closeFocus: false }
    }

    private deviceId1 = React.createRef<HTMLInputElement>();
    private deviceTag1 = React.createRef<HTMLInputElement>();
    private voting1 = React.createRef<HTMLInputElement>();
    private proofTestingInterval1 = React.createRef<HTMLInputElement>();
    private pfdavg1 = React.createRef<HTMLInputElement>();
    private str1 = React.createRef<HTMLInputElement>();
    private hft1 = React.createRef<HTMLSelectElement>();
    

    handleClick = (e) => {
        const manualAction = new ManualAction();
        const newDeviceId1 = this.deviceId1.current.value;
        const newDeviceTag1 = this.deviceTag1.current.value;
        const newVoting1 = this.voting1.current.value;
        const newProofTestingInterval1 = parseFloat(this.proofTestingInterval1.current.value);
        if (newProofTestingInterval1) {
            if (isNaN(newProofTestingInterval1)) {
                // TODO: alert the user
                return
            }
        }
        
        const newPfdAvg1 = parseFloat(this.pfdavg1.current.value);
        if (newPfdAvg1) {
            if (isNaN(newPfdAvg1)) {
                // TODO: alert the user
                return
            }
        }
        
        const newStr1 = parseFloat(this.str1.current.value);
        if (newStr1) {
            if (isNaN(newStr1)) {
                // TODO: alert the user
                return
            }
        }
        
        const newHft1 = parseFloat(this.hft1.current.value);
        if (newHft1) {
            if (isNaN(newHft1)) {
                // TODO: alert the user
                return
            }
      }

      if ((this.proofTestingInterval1.current.value !== '' && isNaN(newProofTestingInterval1)) || isNaN(newPfdAvg1) || isNaN(newStr1) || isNaN(newHft1)) {
        this.props.saveManualActionsFailed(e);
      }
      else {
        manualAction.deviceId = newDeviceId1;
        manualAction.tagName = newDeviceTag1;
        manualAction.voting = newVoting1;
        manualAction.proofTestingInterval = newProofTestingInterval1;
        manualAction.pfd = newPfdAvg1;
        manualAction.stR1Year = newStr1;
        manualAction.hft = newHft1;

        this.props.onManualActionSave(manualAction);
        this.props.closeModal();
      }
        
    }

    onMouseEnter = () => {
        this.setState({
            closeFocus: true
        })
    }

    onMouseLeave = () => {
        this.setState({
            closeFocus: false
        })
    }


    render() {

        const closeModal = this.props.closeModal;

        var closeClass = this.state.closeFocus ? "ui-dialog-titlebar-close ui-corner-all ui-state-hover" : "ui-dialog-titlebar-close ui-corner-all";


        return (

            <SilModal title="Manual Actions" width={480} closeModal={this.props.closeModal}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="well">
                                    <h4>Manual Action</h4>
                                    <table>
                                        <tbody><tr>
                                            <td className="customerLogictable">
                                                <span id="Label44">Device ID</span>
                                            </td>
                                            <td className="customerlogictext">
                                                    <input name="manualActionDeviceId" defaultValue={this.props.manualAction.deviceId ? this.props.manualAction.deviceId : ""} type="text" id="manualActionDeviceId" ref={this.deviceId1}/>
                                            </td>
                                        </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label45">Device Tag</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <input name="manualActionTagName" defaultValue={this.props.manualAction.tagName ? this.props.manualAction.tagName : ""} type="text" id="manualActionTagName" ref={this.deviceTag1}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label50">Voting</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <input name="manualActionVoting" defaultValue={this.props.manualAction.voting ? this.props.manualAction.voting : ""} type="text" id="manualActionVoting" ref={this.voting1}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label51">TI (Yr)</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <input name="manualActionTI" defaultValue={this.props.manualAction.proofTestingInterval ? this.props.manualAction.proofTestingInterval : ""} type="text" id="manualActionTI" ref={this.proofTestingInterval1}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label53">PFDavg</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <input name="manualActionPFD" defaultValue={this.props.manualAction.pfd ? this.props.manualAction.pfd : "0"} type="text" id="manualActionPFD" ref={this.pfdavg1}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label54">STR (1/Yr)</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <input name="manualActionSTR1Year" defaultValue={this.props.manualAction.stR1Year ? this.props.manualAction.stR1Year : "0"} type="text" id="manualActionSTR1Year" ref={this.str1}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label56">HFT</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <select name="manualActionHFT" defaultValue={this.props.manualAction.hft ? this.props.manualAction.hft : ""} id="manualActionHFT" ref={this.hft1}>
                                                        <option value={0}>0</option>
                                                        <option value={1}>1</option>
                                                        <option value={2}>2</option>
                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody></table>
                                </div>
                            </div>
                        </div>
                        <div style={{ textAlign:"left"}}>
                                <input type="submit" name="manualActionSave" defaultValue="Update" id="manualActionSave" className="green-button edit-button" onClick={this.handleClick} />
                        </div>
                    </div>
            </SilModal>
        );
    }
}